import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi, API, downloadBlob } from "../../lib/api";
import { eur, STATUS_LABELS, STATUS_COLORS } from "../../lib/format";
import { Search, Eye, Download, Plus } from "lucide-react";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState("");
  const [search, setSearch] = useState("");
  const nav = useNavigate();

  const load = useCallback(() => adminApi.get("/admin/orders", { params: { status, search } }).then((r) => setOrders(r.data)), [status, search]);
  useEffect(() => { const t = setTimeout(load, 300); return () => clearTimeout(t); }, [load]);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-heading font-bold text-3xl tracking-tighter">Pedidos</h1>
        <div className="flex gap-2">
          <button onClick={() => nav("/admin/pedidos/nuevo")} className="inline-flex items-center gap-2 bg-brand text-white rounded-sm px-3 py-2 text-sm hover:bg-brand-dark" data-testid="new-order-btn"><Plus className="h-4 w-4" /> Nuevo pedido</button>
          <button onClick={() => downloadBlob("/admin/export/orders", "pedidos.csv")} className="inline-flex items-center gap-2 border border-border rounded-sm px-3 py-2 text-sm hover:border-brand" data-testid="export-csv"><Download className="h-4 w-4" /> CSV</button>
          <button onClick={() => downloadBlob("/admin/export-xlsx/orders", "pedidos.xlsx")} className="inline-flex items-center gap-2 bg-emerald-600 text-white rounded-sm px-3 py-2 text-sm hover:bg-emerald-700" data-testid="export-xlsx"><Download className="h-4 w-4" /> Excel</button>
        </div>
      </div>

      <div className="flex flex-wrap gap-3 mb-4">
        <form onSubmit={(e) => { e.preventDefault(); load(); }} className="relative flex-1 max-w-xs">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Buscar nº o cliente..." className="w-full pl-9 pr-3 py-2 text-sm border border-border rounded-sm bg-white" data-testid="order-search" />
        </form>
        <select value={status} onChange={(e) => setStatus(e.target.value)} className="text-sm border border-border rounded-sm px-3 py-2 bg-white" data-testid="order-status-filter">
          <option value="">Todos los estados</option>
          {Object.entries(STATUS_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
      </div>

      <div className="bg-white border border-border rounded-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-brand-ink text-white"><tr><th className="text-left px-3 py-2">Nº</th><th className="text-left px-3 py-2">Fecha</th><th className="text-left px-3 py-2">Cliente</th><th className="text-right px-3 py-2">Total</th><th className="text-center px-3 py-2">Estado</th><th className="text-right px-3 py-2"></th></tr></thead>
          <tbody>
            {orders.length === 0 ? <tr><td colSpan={6} className="py-10 text-center text-muted-foreground">Sin pedidos.</td></tr> :
             orders.map((o, i) => (
              <tr key={o.id} className={`cursor-pointer ${i % 2 ? "bg-secondary/40" : "bg-white"} hover:bg-brand/5`} onClick={() => nav(`/admin/pedidos/${o.id}`)} data-testid={`order-row-${o.number}`}>
                <td className="px-3 py-2 font-mono">{o.number}</td>
                <td className="px-3 py-2 text-muted-foreground">{o.date}</td>
                <td className="px-3 py-2">{o.customer_name}<span className="text-muted-foreground text-xs block">{o.company}</span></td>
                <td className="px-3 py-2 text-right font-medium">{eur(o.total)}</td>
                <td className="px-3 py-2 text-center"><span className={`text-xs px-2 py-0.5 rounded-sm ${STATUS_COLORS[o.status] || "bg-secondary"}`}>{STATUS_LABELS[o.status] || o.status}</span></td>
                <td className="px-3 py-2 text-right"><Eye className="h-4 w-4 inline text-muted-foreground" /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
